export default "__VITE_ASSET__YxWYReUx__"